import { render, staticRenderFns } from "./ModalApoliceSeguroIBP.vue?vue&type=template&id=4dcf4dd2"
import script from "./ModalApoliceSeguroIBP.vue?vue&type=script&lang=js"
export * from "./ModalApoliceSeguroIBP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports